/**
 * @typedef {import('./types').FooterCategory} FooterCategory
 */

/**
 * @type {FooterCategory[]}
 */
export const FOOTER_CATEGORIES = [
  {
    label: 'Adobe',
    analyticsId: 'Adobe-1',
    links: [
      {
        label: 'Adobe.com',
        href: 'https://www.adobe.com/?promoid=ZP46FD38&mv=other',
        analyticsId: 'Adobe_com-1',
      },
      {
        label: 'About Exchange',
        href: 'https://exchange.adobe.com/about',
        analyticsId: 'About_Exchange-2',
      },
    ],
  },
  {
    label: 'Creative Cloud publishers',
    analyticsId: 'Creative_Cloud_publishers-1',
    links: [
      {
        label: 'Create a cloud integration',
        href: 'https://developer.adobe.com/console',
        analyticsId: 'Create_a_cloud_integration-1',
      },
      {
        label: 'Create a UXP or CEP plugin',
        href: 'https://developer.adobe.com/developer-distribution/creative-cloud/',
        analyticsId: 'Create_a_UXP_or_CEP_plugin-2',
      },
    ],
  },
  {
    label: 'Experience Cloud partners',
    analyticsId: 'Experience_Cloud_partners-1',
    links: [
      {
        label: 'Become a partner',
        href: 'https://partners.adobe.com/exchangeprogram/experiencecloud',
        analyticsId: 'Become_a_partner-1',
      },
      {
        label: 'Learn about partner benefits',
        href: 'https://partners.adobe.com/exchangeprogram/experiencecloud/ProgramBenefits.html',
        analyticsId: 'Learn_about_partner_benefits-2',
      },
    ],
  },
  {
    label: 'Community',
    analyticsId: 'Community-1',
    links: [
      {
        label: 'Adobe Exchange Partner Blog',
        href: 'https://blog.adobe.com/',
        analyticsId: 'Adobe_Exchange_Partner_Blog-1',
      },
      {
        label: 'Sign up for the Partner Newsletter',
        href: 'https://www.adobe.com/subscription/ecexchange-newsletter.html',
        analyticsId: 'Sign_up_for_the_Partner_Newsletter-2',
      },
    ],
  },
  {
    label: 'Support',
    analyticsId: 'Support-1',
    links: [
      {
        label: 'Troubleshooting for Creative Cloud',
        href: 'https://helpx.adobe.com/creative-cloud/kb/troubleshoot-common-addon-installation-issues.html',
        analyticsId: 'Troubleshooting_for_Creative_Cloud-1',
      },
    ],
  },
];

const ENV = process.env.REACT_APP_ENVIRONMENT === 'stg1' ? 'stage.' : '';

export const FOOTER_SECONDARY_ROUTES = [
  {
    label: 'Privacy (Updated)',
    href: `https://www.${ENV}adobe.com/privacy.html`,
    analyticsId: 'Privacy-1',
  },
  {
    label: 'Terms of Use',
    href: `https://www.${ENV}adobe.com/legal/terms.html`,
    analyticsId: 'Terms_of_Use-2',
  },
  {
    label: 'Cookie preferences',
    href: '#',
    analyticsId: 'Cookie_preferences-3',
    dataNavAction: 'open-adchoices-modal',
  },
  {
    label: 'Do not sell or share my personal information',
    href: `https://www.${ENV}adobe.com/privacy/us-rights.html`,
    analyticsId: 'Do_not_sell_my_personal_information-4',
  },
  {
    label: 'AdChoices',
    href: `https://www.${ENV}adobe.com/privacy/opt-out.html#interest-based-ads`,
    analyticsId: 'AdChoices-5',
    image: `https://www.${ENV}adobe.com/content/dam/cc/icons/adchoices-small.svg`,
  },
];
